import React from 'react';
import {Styles} from '../../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import axios from "axios";
import {defaultVariabls} from "../../../../../../config/index";
import {connect, setStore} from "trim-redux";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import {Translate} from "../../../../../../config/Translate";
import withWidth from "@material-ui/core/withWidth/withWidth";
import AppCardLoaderFields from "../../../../../components/Skeletons/AppCardLoaderFields";
import Grid from "@material-ui/core/Grid/Grid";
import MakeSlideShowButton from "../MakeSlideShowButton";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton/IconButton";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import DeleteButton from "../../../../../components/elements/DeleteButton";
import Card from "@material-ui/core/Card/Card";

class SlideShowItem extends React.Component {

    onDelete(id){
        let data = new FormData();
        data.append('id',  id);
        this.setState({
            loading: false
        });
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/slideshow/delete`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.deleteData, {
                    variant: 'success',
                });
                this.props.reload();

            })
            .catch(error => {
                console.log(error.response);
                this.loadData();
                this.props.enqueueSnackbar(Translate.deleteDataFailed, {
                    variant: 'error',
                });

                return false
            });
    }

    render(){
        let {item} = this.props;
        let style = item.bg_type === "gradient" ?
            {
                background: `linear-gradient(to right, ${item.bg_color}, ${item.bg_color_2})`,
            } :
            item.bg_type === "solid" ?
                {
                    background: item.bg_color,
                } :
                {
                    backgroundImage: `url("${defaultVariabls.uploads}/FileManager/${item.background.name}.${item.background.extension}")`,
                }
        return (
            <div
                className="slide_show_item"
                style={style}
            >
                {
                    item.active === 1 &&
                        <span className="active-badge">
                            {Translate.active}
                        </span>
                }
                <img src={`${defaultVariabls.uploads}/FileManager/${item.thumbnail.name}.${item.thumbnail.extension}`}/>
                <div className="controller">
                    <MakeSlideShowButton id={item.id} reload={() => this.props.reload()}/>
                    <DeleteButton
                        size="small"
                        handleDelete={() => this.onDelete(item.id)}
                    />
                </div>
            </div>
        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(SlideShowItem)))));